import { render, staticRenderFns } from "./LayerAttribute.vue?vue&type=template&id=ec1174b0"
import script from "./LayerAttribute.vue?vue&type=script&lang=js"
export * from "./LayerAttribute.vue?vue&type=script&lang=js"
import style0 from "./LayerAttribute.vue?vue&type=style&index=0&id=ec1174b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports